__turbopack_context__.v({
  "agent": "ReviewView-module__96ZRtW__agent",
  "agentLit": "ReviewView-module__96ZRtW__agentLit",
  "answer": "ReviewView-module__96ZRtW__answer",
  "body": "ReviewView-module__96ZRtW__body",
  "chip": "ReviewView-module__96ZRtW__chip",
  "dim": "ReviewView-module__96ZRtW__dim",
  "facts": "ReviewView-module__96ZRtW__facts",
  "force": "ReviewView-module__96ZRtW__force",
  "kind": "ReviewView-module__96ZRtW__kind",
  "kindLabel": "ReviewView-module__96ZRtW__kindLabel",
  "kindOptions": "ReviewView-module__96ZRtW__kindOptions",
  "prompt": "ReviewView-module__96ZRtW__prompt",
  "quote": "ReviewView-module__96ZRtW__quote",
  "ring": "ReviewView-module__96ZRtW__ring",
  "statement": "ReviewView-module__96ZRtW__statement",
  "tags": "ReviewView-module__96ZRtW__tags",
  "transcript": "ReviewView-module__96ZRtW__transcript",
  "verb": "ReviewView-module__96ZRtW__verb",
  "verbs": "ReviewView-module__96ZRtW__verbs",
});
